import { Component, h, Host, Listen, Prop, State } from "@stencil/core";
import { QuantityUpdate, UpdateMode } from "@apis/model/add-to-cart-event";
import {
  BcpProductActionContainerProps,
  BcpProductActionContainerState,
  ProductAddedEventDetails,
} from "./bcp-product-action-container-model";

@Component({
  tag: "bcp-product-action-container",
  styleUrl: "bcp-product-action-container.scss",
})
export class BcpProductActionContainer {
  @Prop() productCode: BcpProductActionContainerProps["productCode"];
  @Prop() variant: BcpProductActionContainerProps["variant"];
  @Prop()
  initialQuantity: BcpProductActionContainerProps["initialQuantity"] = 1;
  @Prop()
  resetQuantityAfterAdding: BcpProductActionContainerProps["resetQuantityAfterAdding"] =
    false;

  @State() quantity: BcpProductActionContainerState["quantity"];
  @State() mode: BcpProductActionContainerState["mode"] = UpdateMode.INPUT;

  @Listen("quantityChanged", { target: "document" })
  onQuantityChange({
    detail: { productCode, quantity },
  }: CustomEvent<QuantityUpdate>): void {
    if (productCode != this.productCode) return;
    this.quantity = quantity;
  }

  @Listen("productAdded", { target: "document" })
  @Listen("productAddedToInquiry", { target: "document" })
  @Listen("productAddedToWishlist", { target: "document" })
  onProductAdded({
    detail: { productCode },
  }: CustomEvent<ProductAddedEventDetails>): void {
    if (this.resetQuantityAfterAdding && productCode === this.productCode) {
      this.quantity = this.initialQuantity;
    }
  }

  componentWillLoad(): void {
    this.quantity = this.initialQuantity;
  }

  render() {
    return (
      <Host>
        <div class="product-action__price-container">
          <slot name="price-container"></slot>
        </div>
        <div class="product-action__quantity-updater-container">
          <bcp-with-product-details
            productCode={this.productCode}
            quantity={this.quantity}
            mode={this.mode}
          >
            <slot name="quantity-updater"></slot>
          </bcp-with-product-details>
        </div>
        <div
          class={{
            "product-action__action-buttons-container": true,
            "product-action__action-buttons-container--grid":
              this.variant === "grid",
          }}
        >
          <bcp-with-product-details
            productCode={this.productCode}
            quantity={this.quantity}
          >
            <slot name="action-buttons"></slot>
          </bcp-with-product-details>
        </div>
      </Host>
    );
  }
}
